let smoother = null;
let observer = null;

const scrollResizeControlClear = (gsapRef, scrollTriggerRef, observerRef, scrollSmootherRef) => {
  console.log("scrollResizeControlClear called");

  if(smoother) { smoother.kill(); smoother = null; }
  if(observer) { observer.kill(); observer = null; }
  if(scrollSmootherRef.get()) scrollSmootherRef.get().kill();
  scrollTriggerRef.getAll().forEach(t => t.kill());
}

const scrollResizeControlMake = (gsapRef, scrollTriggerRef, observerRef, scrollSmootherRef, page) => {
  console.log("scrollResizeControlMake called: " + page);

  let wrapper = ".part.page-" + page;
  
  scrollTriggerRef.normalizeScroll(true);

  smoother = scrollSmootherRef.create({
    wrapper: wrapper,
    content: wrapper + ' .part-in',
    smooth: 1,
    smoothTouch: 1,
    speed: 0.3,
    // ease: 'none',
    effects: true,
    normalizeScroll: true,
    ignoreMobileResize: true,
    onUpdate: (self) => {
      // console.log(`ScrollSmoother: onUpdate: velocity:`, self.getVelocity());
    },
    onStop: (self) => {
      // console.log(`ScrollSmoother: onStop: self:`, self);
    }
  });

  observer = scrollTriggerRef.observe({
    type: "wheel,touch,scroll,pointer", // comma-delimited list of what to listen for
    onChange: (self) => {
      // console.log(`Observer: onChange: deltaY(${self.deltaY}), velocitY(${self.velocityY})`);
    },
    // onUp: (self) => {},
    // onDown: (self) => {},
    // onLeft: (self) => {},
    // onRight: (self) => {},
    // onPress: (self) => {},
    // onRelease: (self) => {},
    // onStop: (self) => {},
    // preventDefault: true, // prevent default scrolling behaviour
    // tolerance: 10,
  });

  scrollTriggerRef.refresh();

  ////////// jess: Dev, comment for production [START]
  window.smootherRef = smoother; // jess: Dev
  window.observerRef = observer; // jess: Dev
  ////////// jess: Dev, comment for production [END]
}

export {
  smoother,
  observer,
  scrollResizeControlClear,
  scrollResizeControlMake
}